export default function DocsFeaturesDetail() {
  return null
}
